import * as React from "react";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {
  Radio,
  RadioGroup,
  TextField,
  FormControl,
  FormControlLabel,
  FormLabel,
  Autocomplete,
  Button,
  Checkbox,
} from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useForm, Controller, FieldValues } from "react-hook-form";
import { useAppSelector } from "../../../redux/hooks";
import { updateInvestmentAppraisal } from "../../../redux/slices/UpdateInvestmentMasterAppraisalValueSlice";
import { InvestmentMasterAppraisalValue } from "../../../all_Interfaces";
import { useDispatch } from "react-redux";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const InvestmentAppraisalValuesForm = (props: any) => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const page = params.page;
  const userId = params.userRoleId;
  const [investmentAppraisalValues, setInvestmentAppraisalValues] =
    useState<InvestmentMasterAppraisalValue>({
      lastAppraisedValue: 0,
      lastAnnualAppraisedValue: 0,
      nextAppraisalDate: "",
      appraisalStatus: "",
      lastAppraisalDate: "",
      lastAnnualAppraisalDate: "",
      lastAppraisalType: "",
      lastDLAppraisedValue: 0,
      lastDLAnnualAppraisedValue: 0,
      lastDLAppraisalDate: "",
      lastDLAnnualAppraisalDate: "",
    });

  const { control, handleSubmit } = useForm({});
  const investmentMasterAppraisalValues: InvestmentMasterAppraisalValue =
    useAppSelector((state) => state.UpdateInvestmentMasterAppraisal.data);
  const AppraisalStatus = ["Completed", "InProgess"];

  const handleNextAppraisalDate = (d: Dayjs | null) => {
    if (d != null) {
      dispatch(
        updateInvestmentAppraisal({
          ...investmentAppraisalValues,
          nextAppraisalDate: d.format("MM-DD-YYYY"),
        })
      );
    }
  };
  const handleAppraisalStatusChange = (status: string) => {
    dispatch(
      updateInvestmentAppraisal({
        ...investmentAppraisalValues,
        appraisalStatus: status,
      })
    );
  };

  const handleLastAppraisalTypeChange = (type: string) => {
    dispatch(
      updateInvestmentAppraisal({
        ...investmentAppraisalValues,
        lastAppraisalType: type,
      })
    );
  };

  const handleLastAppraisalValueChange = (value: number) => {
    dispatch(
      updateInvestmentAppraisal({
        ...investmentAppraisalValues,
        lastAppraisedValue: value,
      })
    );
  };

  const handleLastAnnualAppraisalValueChange = (value: number) => {
    dispatch(
      updateInvestmentAppraisal({
        ...investmentAppraisalValues,
        lastAnnualAppraisedValue: value,
      })
    );
  };

  const handleDLAppraisalValueChange = (value: number) => {
    dispatch(
      updateInvestmentAppraisal({
        ...investmentAppraisalValues,
        lastDLAppraisedValue: value,
      })
    );
  };

  const handleDLAnnualAppraisalValueChange = (value: number) => {
    dispatch(
      updateInvestmentAppraisal({
        ...investmentAppraisalValues,
        lastDLAnnualAppraisedValue: value,
      })
    );
  };

  const handleLastAppraisalDate = (d: Dayjs | null) => {
    if (d != null) {
      dispatch(
        updateInvestmentAppraisal({
          ...investmentAppraisalValues,
          lastAppraisalDate: d.format("MM-DD-YYYY"),
        })
      );
    }
  };
  const handleLastAnnualAppraisalDate = (d: Dayjs | null) => {
    if (d != null) {
      dispatch(
        updateInvestmentAppraisal({
          ...investmentAppraisalValues,
          lastAnnualAppraisalDate: d.format("MM-DD-YYYY"),
        })
      );
    }
  };
  const handleDLAppraisalDate = (d: Dayjs | null) => {
    if (d != null) {
      dispatch(
        updateInvestmentAppraisal({
          ...investmentAppraisalValues,
          lastDLAppraisalDate: d.format("MM-DD-YYYY"),
        })
      );
    }
  };
  const handleDLAnnualAppraisalDate = (d: Dayjs | null) => {
    if (d != null) {
      dispatch(
        updateInvestmentAppraisal({
          ...investmentAppraisalValues,
          lastDLAnnualAppraisalDate: d.format("MM-DD-YYYY"),
        })
      );
    }
  };

  useEffect(() => {
    setInvestmentAppraisalValues({
      ...investmentMasterAppraisalValues,
      nextAppraisalDate:
        investmentMasterAppraisalValues.nextAppraisalDate != null
          ? investmentMasterAppraisalValues.nextAppraisalDate
          : "",
      lastAnnualAppraisalDate:
        investmentMasterAppraisalValues.lastAnnualAppraisalDate != null
          ? investmentMasterAppraisalValues.lastAnnualAppraisalDate
          : "",
      lastAnnualAppraisedValue:
        investmentMasterAppraisalValues.lastAnnualAppraisedValue != null
          ? investmentMasterAppraisalValues.lastAnnualAppraisedValue
          : 0,
      lastAppraisalDate:
        investmentMasterAppraisalValues.lastAppraisalDate != null
          ? investmentMasterAppraisalValues.lastAppraisalDate
          : "",
      lastAppraisedValue:
        investmentMasterAppraisalValues.lastAppraisedValue != null
          ? investmentMasterAppraisalValues.lastAppraisedValue
          : 0,
      lastAppraisalType:
        investmentMasterAppraisalValues.lastAppraisalType != null
          ? investmentMasterAppraisalValues.lastAppraisalType
          : "",
      appraisalStatus:
        investmentMasterAppraisalValues.appraisalStatus != null
          ? investmentMasterAppraisalValues.appraisalStatus
          : "",
      lastDLAnnualAppraisalDate:
        investmentMasterAppraisalValues.lastDLAnnualAppraisalDate != null
          ? investmentMasterAppraisalValues.lastDLAnnualAppraisalDate
          : "",
      lastDLAnnualAppraisedValue:
        investmentMasterAppraisalValues.lastDLAnnualAppraisedValue != null
          ? investmentMasterAppraisalValues.lastDLAnnualAppraisedValue
          : 0,
      lastDLAppraisalDate:
        investmentMasterAppraisalValues.lastDLAppraisalDate != null
          ? investmentMasterAppraisalValues.lastDLAppraisalDate
          : "",
      lastDLAppraisedValue:
        investmentMasterAppraisalValues.lastDLAppraisedValue != null
          ? investmentMasterAppraisalValues.lastDLAppraisedValue
          : 0,
    });
  }, [investmentMasterAppraisalValues]);
  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <Grid container spacing={3}>
        <Grid item xs={6} sm={6} sx={{ marginTop: "-8px" }}>
          <Controller
            name="NextAppraisalDate"
            control={control}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["DatePicker", "DatePicker", "DatePicker"]}
                >
                  <DatePicker
                    readOnly={props.page === "view"}
                    label="Next Appraisal Date"
                    name="NextAppraisalDate"
                    format="MMM-DD-YYYY"
                    value={
                      investmentAppraisalValues.nextAppraisalDate === "" ||
                        investmentAppraisalValues.nextAppraisalDate == null
                        ? null
                        : dayjs(
                          investmentAppraisalValues.nextAppraisalDate,
                          "MM-DD-YYYY"
                        )
                    }
                    views={["month", "day", "year"]}
                    onChange={(newValue: Dayjs | null) =>
                      handleNextAppraisalDate(newValue)
                    }
                    //   sx={{ width: 300 }}
                    slotProps={{ textField: { size: "small" } }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <Controller
            name="AppraisalStatus"
            control={control}
            render={({ field }) => (
              <Autocomplete
                readOnly={props.page === "view"}
                id="AppraisalStatus"
                options={AppraisalStatus}
                value={investmentAppraisalValues.appraisalStatus}
                onChange={(event, value) => {
                  handleAppraisalStatusChange(value != null ? value : "");
                }}
                // sx={{ width: 400 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Appraisal Status"
                    size="small"
                  />
                )}
              />
            )}
          />
        </Grid>
        <Grid item xs={6} sm={6} sx={{ marginTop: "1px" }}>
          <Controller
            name="LastAppraisalType"
            control={control}
            render={({ field }) => (
              <TextField
                InputProps={{
                  readOnly: page === "view",
                }}
                label="Last Appraisal Type"
                value={investmentAppraisalValues.lastAppraisalType}
                onChange={(e) => {
                  handleLastAppraisalTypeChange(e.target.value);
                }}
                variant="outlined"
                size="small"
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <Controller
            name="LastAppraisalValue"
            control={control}
            render={({ field }) => (
              <TextField
                InputProps={{
                  readOnly: page === "view",
                }}
                label="Last Appraisal Value"
                value={investmentAppraisalValues.lastAppraisedValue}
                onChange={(e) => {
                  handleLastAppraisalValueChange(parseFloat(e.target.value));
                }}
                variant="outlined"
                size="small"
                type="number"
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={6} sm={6} sx={{ marginTop: "3px" }}>
          <Controller
            name="LastAnnualAppraisalValue"
            control={control}
            render={({ field }) => (
              <TextField
                InputProps={{
                  readOnly: page === "view",
                }}
                label="Last Annual Appraisal Value"
                value={investmentAppraisalValues.lastAnnualAppraisedValue}
                onChange={(e) => {
                  handleLastAnnualAppraisalValueChange(
                    parseFloat(e.target.value)
                  );
                }}
                variant="outlined"
                size="small"
                type="number"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={6} sm={6} sx={{ marginTop: "-5px" }}>
          <Controller
            name="LastAppraisalDate"
            control={control}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["DatePicker", "DatePicker", "DatePicker"]}
                >
                  <DatePicker
                    readOnly={props.page === "view"}
                    name="LastAppraisalDate"
                    format="MMM-DD-YYYY"
                    value={
                      investmentAppraisalValues.lastAppraisalDate === "" ||
                        investmentAppraisalValues.lastAppraisalDate == null
                        ? null
                        : dayjs(
                          investmentAppraisalValues.lastAppraisalDate,
                          "MM-DD-YYYY"
                        )
                    }
                    views={["month", "day", "year"]}
                    onChange={(newValue: Dayjs | null) =>
                      handleLastAppraisalDate(newValue)
                    }
                    //   sx={{ width: 300 }}
                    slotProps={{ textField: { size: "small" } }}
                    label="Last Appraisal Date"
                  />
                </DemoContainer>
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <Controller
            name="LastAnnualAppraisalDate"
            control={control}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["DatePicker", "DatePicker", "DatePicker"]}
                >
                  <DatePicker
                    readOnly={props.page === "view"}
                    name="LastAnnualAppraisalDate"
                    format="MMM-DD-YYYY"
                    value={
                      investmentAppraisalValues.lastAnnualAppraisalDate ===
                        "" ||
                        investmentAppraisalValues.lastAnnualAppraisalDate == null
                        ? null
                        : dayjs(
                          investmentAppraisalValues.lastAnnualAppraisalDate,
                          "MM-DD-YYYY"
                        )
                    }
                    views={["month", "day", "year"]}
                    onChange={(newValue: Dayjs | null) =>
                      handleLastAnnualAppraisalDate(newValue)
                    }
                    //   sx={{ width: 300 }}
                    slotProps={{ textField: { size: "small" } }}
                    label="Last Annual Appraisal Date"
                  />
                </DemoContainer>
              </LocalizationProvider>
            )}
          />
        </Grid>
        {props.isDebtLiability === "Yes" && (
          <>
            <Grid item xs={6} sm={6} sx={{ marginTop: "8px" }}>
              <Controller
                name="DLLastAppraisalValue"
                control={control}
                render={({ field }) => (
                  <TextField
                    InputProps={{
                      readOnly: page === "view",
                    }}
                    label="DL Last Appraisal Value"
                    value={investmentAppraisalValues.lastDLAppraisedValue}
                    onChange={(e) => {
                      handleDLAppraisalValueChange(parseFloat(e.target.value));
                    }}
                    variant="outlined"
                    size="small"
                    type="number"
                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid item xs={6} sm={6}>
              <Controller
                name="DLLastAppraisalDate"
                control={control}
                render={({ field }) => (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer
                      components={["DatePicker", "DatePicker", "DatePicker"]}
                    >
                      <DatePicker
                        readOnly={props.page === "view"}
                        name="DLLastAppraisalDate"
                        format="MMM-DD-YYYY"
                        value={
                          investmentAppraisalValues.lastDLAppraisalDate ===
                            "" ||
                            investmentAppraisalValues.lastDLAppraisalDate == null
                            ? null
                            : dayjs(
                              investmentAppraisalValues.lastDLAppraisalDate,
                              "MM-DD-YYYY"
                            )
                        }
                        views={["month", "day", "year"]}
                        onChange={(newValue: Dayjs | null) =>
                          handleDLAppraisalDate(newValue)
                        }
                        //   sx={{ width: 300 }}
                        slotProps={{ textField: { size: "small" } }}
                        label="DL Last Appraisal Date"
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                )}
              />
            </Grid>

            <Grid item xs={6} sm={6} sx={{ marginTop: "8px" }}>
              <Controller
                name="DLLastAnnualAppraisalValue"
                control={control}
                render={({ field }) => (
                  <TextField
                    InputProps={{
                      readOnly: page === "view",
                    }}
                    label="DL Last Annual Appraisal Value"
                    value={investmentAppraisalValues.lastDLAnnualAppraisedValue}
                    onChange={(e) => {
                      handleDLAnnualAppraisalValueChange(
                        parseFloat(e.target.value)
                      );
                    }}
                    variant="outlined"
                    size="small"
                    type="number"
                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid item xs={6} sm={6}>
              <Controller
                name="DLLastAnnualAppraisalDate"
                control={control}
                render={({ field }) => (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer
                      components={["DatePicker", "DatePicker", "DatePicker"]}
                    >
                      <DatePicker
                        readOnly={props.page === "view"}
                        name="DLLastAnnualAppraisalDate"
                        format="MMM-DD-YYYY"
                        value={
                          investmentAppraisalValues.lastDLAnnualAppraisalDate ===
                            "" ||
                            investmentAppraisalValues.lastDLAnnualAppraisalDate ==
                            null
                            ? null
                            : dayjs(
                              investmentAppraisalValues.lastDLAnnualAppraisalDate,
                              "MM-DD-YYYY"
                            )
                        }
                        views={["month", "day", "year"]}
                        onChange={(newValue: Dayjs | null) =>
                          handleDLAnnualAppraisalDate(newValue)
                        }
                        //   sx={{ width: 300 }}
                        slotProps={{ textField: { size: "small" } }}
                        label="DL Last Annual Appraisal Date"
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                )}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};
